import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { IAppConfig }from './app.config.model';

@Injectable()
export class AppConfig{

    static configs : IAppConfig;

    constructor(private http: Http){}

    load(url:string){
        return new Promise<void>((resolve, reject)=>{
           this.http.get(url).toPromise().then((response : Response) => {
                AppConfig.configs = <IAppConfig>response.json();
                resolve();
            }).catch((response: any) => {
                reject(`Could not load file '${url}': ${JSON.stringify(response)}`);
            });
        })
    }

    getAppConfig():IAppConfig{
        return AppConfig.configs;
    }
}